module.exports = __WEBPACK_EXTERNAL_MODULE_46__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getYear"],"commonjs":"date-fns/get_year/index","commonjs2":"date-fns/get_year/index","amd":"date-fns/get_year/index"}
// module id = 46
// module chunks = 0